// extracted by extract-css-chunks-webpack-plugin
module.exports = {"buttons":"dialog__buttons--AHR1z","text":"dialog__text--3FDQq"};